import { render } from "./DownCounter.vue?vue&type=template&id=398f3352"
import script from "./DownCounter.vue?vue&type=script&lang=js"
export * from "./DownCounter.vue?vue&type=script&lang=js"

import "./DownCounter.vue?vue&type=style&index=0&id=398f3352&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__